import { render, staticRenderFns } from "./ImageFileCard.vue?vue&type=template&id=a5c68b14&scoped=true"
import script from "./ImageFileCard.vue?vue&type=script&lang=js"
export * from "./ImageFileCard.vue?vue&type=script&lang=js"
import style0 from "./ImageFileCard.vue?vue&type=style&index=0&id=a5c68b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c68b14",
  null
  
)

export default component.exports